import styled, { css } from 'styled-components';
import { rem } from 'polished';
import Icon from '../Icon';
import BoxText from '../BoxText';
import mediaqueries from '../../../config/themes/variables/mediaqueries';

import { ButtonArrowLeft, ButtonArrowRight } from '../ButtonArrows';

// Caja icono fullscreen
export const StyledBoxFull = styled.div`
  align-items: center;
  background-color: ${props => props.theme.colors.dark}7F;
  cursor: pointer;
  display: none;
  justify-content: center;
  padding: ${rem('11px')};
  position: absolute;
  right: 0;
  top: 0;
  z-index: 1;
  ${props =>
    props.home &&
    css`
      display: none;
    `};
  ${mediaqueries.greaterThan('desktop')`
    display:flex;
  `};
`;

// Icono fullscreen
export const StyledFullScreen = styled(Icon)`
  height: ${rem('18px')};
  width: ${rem('18px')};
`;

// Style Imagen
export const StyledImage = styled.img`
  height: auto;
  width: 100%;
`;

// Número de imagen
export const StyledNumber = styled.div`
  align-items: center;
  background-color: ${props => props.theme.colors.dark}7F;
  bottom: ${rem('-1px')};
  color: ${props => props.theme.colors.light};
  display: none;
  font-family: ${props => props.theme.fonts.medium};
  font-size: ${props => props.theme.fontSize.small};
  justify-content: center;
  min-width: ${rem('45px')};
  padding: ${rem('8px')} ${rem('10px')} ${rem('7.5px')} ${rem('10px')};
  position: absolute;
  right: ${rem('80px')};
  transition: all 0.3s ease-in 0s;
  z-index: 1;
  ${mediaqueries.greaterThan('desktop')`
    display:flex;
  `};
`;

// Flechas
export const StyledArrowLeft = styled(ButtonArrowLeft)`
  background-color: ${props => props.theme.colors.dark}B0;
  left: ${rem('41px')};
  transform: translate(-50%, -50%);
  > svg {
    fill: ${props => props.theme.colors.light};
    margin-top: ${rem('14px')};
    margin-left: ${rem('8px')};
  }
  bottom: 0;
  display: flex;
  top: auto;
  transform: translate(0);
  left: auto;
  right: ${rem('40px')};
  > svg {
    margin-top: inherit;
    margin-left: inherit;
  }
`;

export const StyledArrowRight = styled(ButtonArrowRight)`
  background-color: ${props => props.theme.colors.dark}B0;
  transform: translate(-50%, -50%);
  > svg {
    fill: ${props => props.theme.colors.light};
    margin-top: ${rem('14px')};
    margin-left: ${rem('8px')};
  }
  bottom: 0;
  display: flex;
  top: auto;
  transform: translate(0);
  left: auto;
  right: 0;
  > svg {
    margin-top: inherit;
    margin-left: inherit;
  }
`;

// Caja posiciona contenido
export const StyledItems = styled.div`
  cursor: pointer;
  height: 100%;
  overflow: hidden;
  position: absolute;
  width: 100%;
`;

// Caja: Ver galería + icono cámara
export const StyledViewGallery = styled.button`
  align-items: center;
  background-color: ${props => props.theme.colors.dark};
  border: 0;
  bottom: 0;
  cursor: pointer;
  display: flex;
  padding: 0 ${rem('10px')};
  position: absolute;
  right: 0;
  z-index: 1;
  ${mediaqueries.greaterThan('desktop')`
    display:none;
  `};
`;

// Texto: ver galería
export const StyledText = styled.span`
  color: ${props => props.theme.colors.light};
  line-height: ${rem('30px')};
  font-family: ${props => props.theme.fonts.medium};
  font-size: ${props => props.theme.fontSize.xsmall};
  text-transform: uppercase;
  ${mediaqueries.greaterThan('mobile')`
    font-size: ${props => props.theme.fontSize.small};
  `};
`;

// Icono Cámara
export const StyledCamera = styled(Icon)`
  height: ${rem('18px')};
  margin-right: ${rem('7px')};
  width: ${rem('23px')};
`;
export const StyledBoxTextGallery = styled(BoxText)`
  display: none;
  ${mediaqueries.greaterThan('desktop')`
      display:flex;
  `};
`;

// Imagen
export const StyledImg = styled.div`
  img {
    width: 100%;
  }
`;

// Capa principal galeria
export const StyledGallery = styled.div`
  cursor: pointer;
  margin-bottom: ${rem('19px')};
  overflow: hidden;
  padding-top: 56%;
  position: relative;
  width: 100%;
  ${props =>
    props.home &&
    css`
      margin-bottom: 0;
      ${StyledArrowRight}, ${StyledArrowLeft} {
        display: flex;
      }
    `};
`;
